import 'swiper/css';
import 'swiper/css/pagination';

import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { marketStockExchangeSlice } from '!views/Market/StockExchange/_marketStockExchange.slice';
import { getSelectedTitle } from '!views/Market/StockExchange/marketStockExchange.seletors';
import { uuidSelector } from '»components/Auth';
import {
  Details,
  DocumentsList,
  LastTrades,
  MarketDepht,
} from '»components/molecules/TrlDetailsIntrument';
import { TrlMarketDetails } from '»components/organisms';

import { PrivateView } from '../../../../components/templates/PrivateView';

export const TrlStockExchangeMarketDetails = () => {
  const dispatch = useDispatch();

  const selectedTitle = useSelector(getSelectedTitle);
  const uuid = useSelector(uuidSelector);

  const swiperSlides = [
    { label: 'TRLT_UI-DEPTH', component: <MarketDepht /> },
    {
      label: 'TRLT_UI-EVENT_TYPE',
      component: <Details />,
    },
    { label: 'TRLT_UI-LAST_DETALS', component: <LastTrades /> },
    {
      label: 'TRLT_UI-DOCUMENTS',
      component: <DocumentsList />,
    },
  ];

  const negotiationButtons = [
    {
      id: 'btnOpenSaleModal',
      label: 'TRLT_UI-SALE',
      icon: faMinus,
      operationType: 2,
    },
    {
      id: 'btnOpenPurchaseModal',
      label: 'TRLT_UI-PURCHASE',
      icon: faPlus,
      operationType: 1,
    },
  ];

  useEffect(() => {
    dispatch(
      marketStockExchangeSlice.actions.marketStockExchangeInstrumentRequest({
        symbol: selectedTitle.symbol,
        exchange: selectedTitle.exchange,
        securityType: selectedTitle.securityType,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  return (
    <PrivateView>
      <TrlMarketDetails
        selectedTitle={selectedTitle}
        swiperSlides={swiperSlides}
        negotiationButtons={negotiationButtons}
      />
    </PrivateView>
  );
};
